import React from "react";

export interface CheckBoxComponentType
  extends React.DelHTMLAttributes<HTMLInputElement> {
  title?: string;
  value?: string;
  className?: string;
  inputClass?: string;
  checked?: boolean;
  disabled?: boolean;
}

const CheckBoxComponent = ({
  title,
  className,
  checked,
  children,
  inputClass,
  ...props
}: CheckBoxComponentType) => {
  return (
    <div className={`form-control rounded-none ${className}`}>
      <label className="label flex cursor-pointer flex-row items-center justify-start space-x-3 truncate whitespace-nowrap">
        <input
          {...props}
          checked={checked}
          type="checkbox"
          className={"checkbox-primary checkbox " + inputClass}
        />
        {children ? (
          children
        ) : (
          <span className="text-sm capitalize lg:text-base">{title}</span>
        )}
      </label>
    </div>
  );
};

export default CheckBoxComponent;
